import { createAction } from '@reduxjs/toolkit';
import { Asset, Comment } from '../../api';
import { CommentState } from './model';

export const loadRequested = createAction<{ assetId: Asset['id'] }>('al/comment/loadRequested');

export const commentsLoaded = createAction<{ assetId: Asset['id']; comments: Comment[] }>(
  'al/comment/commentsLoaded',
);

export const addClicked = createAction<{ assetId: Asset['id']; content: Comment['content'] }>(
  'al/comment/addClicked',
);

export const setInProgress = createAction<{ assetId: Asset['id']; inProgress: boolean }>(
  'al/comment/setInProgress',
);

export const deleteClicked = createAction<{ assetId: Asset['id']; commentId: Comment['id'] }>(
  'al/comment/deleteClicked',
);

export const changeSubmitted = createAction<{
  assetId: Asset['id'];
  commentId: Comment['id'];
  content: Comment['content'];
}>('al/comment/changeSubmitted');

export const setEditingComment = createAction<CommentState['editingComment']>(
  'al/comment/setEditingComment',
);

export const setNewComment = createAction<CommentState['newComment']>('al/comment/setNewComment');
